import _ from 'lodash';
import { TEMPLATE_MAPPER as types } from 'actions/actionTypes';
import { templateToTimeline } from 'selectors/timeline';

const initialState = {
  template: {
    name: '',
    id: null
  },
  items: [],
  groups: [],
  assignableUsers: [],
  visible: false,
  rosterEventDetail: {
    insertTime: null,
    insertGroupId: null
  },
  loading: false
};

export const templateMapper = (state = initialState, action) => {
  switch (action.type) {
  // /////////////////////////////////////////////////////////////////////////
  case types.LOADING_FAILED: {
    return initialState;
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.LOADING_IN_PROGRESS: {
    return { ...state, loading: true };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.LOADED_TEMPLATE_SUCCESS: {
    const { items, groups, template } = templateToTimeline(action.ActivityTemplate);
    const users = _.cloneDeep(state.assignableUsers);

    // Add the template user to the user group
    for (let i = 0; i < groups.length; i++) {
      groups[i].assignedUser = users[i];
    }

    return {
 ...state,
items,
      groups,
      template,
      loading: false
};
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.REMOVE_ASSIGNED_USER: {
    const { placeHolderGroupId } = action;
    const groups = _.cloneDeep(state.groups);

    // Find the existing group id and remove the assigned user.
    const idx = groups.findIndex(g => g.id === placeHolderGroupId);
    groups[idx].assignedUser = null;

    return { ...state, groups };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.ASSIGN_USER_TO_PLACEHOLDER: {
    const { placeHolderGroupId, user } = action;
    const groups = _.cloneDeep(state.groups);

    // Find the existing group id and assign the incoming user as the assigned.
    const idx = groups.findIndex(g => g.id === placeHolderGroupId);

    groups[idx].assignedUser = user;

    return { ...state, groups };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.SWAP_USER_WITH_PLACEHOLDER: {
    const { toGroupId, fromGroupId } = action;
    const groups = _.cloneDeep(state.groups);

    const toGroupIdx = groups.findIndex(g => g.id === toGroupId);

    const fromGroupIdx = groups.findIndex(g => g.id === fromGroupId);

    const toAssignedUser = groups[toGroupIdx].assignedUser;
    const fromAssignedUser = groups[fromGroupIdx].assignedUser;

    groups[toGroupIdx].assignedUser = fromAssignedUser;
    groups[fromGroupIdx].assignedUser = toAssignedUser;

    return { ...state, groups };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.REORDER_ASSIGNED_USER: {
    const { toGroupId, fromGroupId } = action;

    if (toGroupId === fromGroupId || toGroupId === 0) {
      return state;
    }

    const groups = _.cloneDeep(state.groups);

    const fromGroupIdx = groups.findIndex(g => g.id === fromGroupId);
    const fromAssignedUser = groups[fromGroupIdx].assignedUser;

    const minGroupId = Math.min(toGroupId, fromGroupId);
    const maxGroupId = Math.max(toGroupId, fromGroupId);

    // Determine the direction, eg bubble up or bubble down
    // +1 is a bubble up, -1 is a bubble down. In reality,
    // this is modelled by reversing the affected array items
    const incr = Math.sign(toGroupId - fromGroupId);

    // filter the groups to the set that are being reordered, minus
    // any unassigned users in between
    let targetGroups = groups.filter((g) => {
      if (g.id >= minGroupId && g.id <= maxGroupId && g.assignedUser) {
        return g;
      }
      return false;
    });

    targetGroups = incr < 0 ? targetGroups.reverse() : targetGroups;

    const unchangedGroups = groups.filter((g) => {
      if (!(g.id >= minGroupId && g.id <= maxGroupId && g.assignedUser)) {
        return g;
      }
      return false;
    });

    // Reassign the users accordingly
    for (let i = 0; i < targetGroups.length; i++) {
      const g = targetGroups[i];
      if (g.id === toGroupId) {
        // assign the from user to the new 'to' group
        // this is the only explict option we need to cater for
        // since it is always a forward traversal of the array
        g.assignedUser = fromAssignedUser;
      }
      else {
        g.assignedUser = targetGroups[i + 1].assignedUser;
      }
    }

    // Re-sort the groups to be in the correct order
    const newGroups = _.concat(unchangedGroups, targetGroups)
      .sort((a, b) => a.id - b.id);

    return { ...state, groups: newGroups };
  }

  // /////////////////////////////////////////////////////////////////////////
  case types.ADD_ROSTER_EVENT_DETAILS: {
    const { insertTime, insertGroupId, selectedTemplate } = action;
    const template = {
      name: selectedTemplate.name,
      id: selectedTemplate.id
    };

    // Remove unallocated user
    const users = _.filter(action.users, u => u.uid !== -1);

    // Reorder the user list so that it starts at the insertGroupId.
    // Anything before this mark is placed at the end of the
    const startIndex = users.findIndex(u => u.id === insertGroupId);
    const startGroup = _.slice(users, 0, startIndex);
    const endGroup = _.slice(users, startIndex);

    const orderedUsers = _.concat(endGroup, startGroup);
    const rosterEventDetail = {
      insertTime,
      insertGroupId
    };

    return {
 ...state,
items: [],
      groups: [],
      assignableUsers: orderedUsers,
      template,
      rosterEventDetail
};
  }

  default:
    return state;
  }
};
